import classNames from 'classnames';
import React from 'react';
import Icon from 'components/styleguide/icon/Icon';
import { nextSkillState, SkillState } from './utils/curationScoring';

const styles = require('./SkillToggle.module.scss');

const STATE_LABELS: Record<SkillState, string> = {
  explicit: 'Explicit',
  inferred: 'Inferred',
  not_found: 'Not found',
};

const STATE_ICONS: Record<SkillState, string> = {
  explicit: 'check',
  inferred: 'circleHelp',
  not_found: 'x',
};

export interface Props {
  disabled?: boolean;
  evidence?: string;
  name: string;
  onChange: (name: string, next: SkillState) => void;
  state: SkillState;
}

// A skill classification as a real button pill: click or Enter cycles
// Explicit -> Inferred -> Not found. The parenthetical carries the AI's
// evidence; state is carried by icon + text, never by color alone.
export default function SkillToggle({ disabled = false, evidence, name, onChange, state }: Props) {
  const next = nextSkillState(state);
  const note = evidence && evidence !== '' ? evidence : STATE_LABELS[state].toLowerCase();

  return (
    <button
      aria-label={`${name}: ${STATE_LABELS[state]} (${note}). Press to change to ${STATE_LABELS[next]}.`}
      className={classNames(styles['ui-skill-toggle'], styles[`ui-skill-toggle--${state}`])}
      disabled={disabled}
      onClick={() => onChange(name, next)}
      title="Click to change classification"
      type="button"
    >
      <Icon aria-hidden name={STATE_ICONS[state]} size="sm" />
      <span className={styles['ui-skill-toggle__name']}>{name}</span>
      <span className={styles['ui-skill-toggle__note']}>({note})</span>
    </button>
  );
}
